const Images = {
    Logo: "/assets/img/login-vlogo.svg",
    headerLogo: "/assets/img/login-vlogo.svg",
};

export default Images;  
